const PhoneRegexPatterns = {
    Int: /([0-9]{4})[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})/,
    IntAlt: /([0-9]{5})[-.\s]?([0-9]{3})[-.\s]?([0-9]{3})/,
    US: /^(1|001\s?)?[2-9]{1}((\([0-9]{2}\))|[0-9]{2})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/im
};
export default PhoneRegexPatterns;
